<template>
	<div class="layout-inner career_details">

    <navbar></navbar>

    <div class="layout-container">
      <div class="layout-content" style="position: relative;">

      	<template v-if="isLoading">
          <div class="w-100" style="padding: 150px 0;">
            <spinner size="large"></spinner>
          </div>
        </template>

				<template v-else>

					<template v-if="career && career.name">
      			<career-title :career="career"></career-title>
      		</template>

					<template v-if="isEMSIFeatureEnabled">
            <div class="sub_hd_bar">
              <div class="sub_hd_ic">
								<span @click="isStateCityFilterClicked = true" class="filter">
									<span class="ic ic-filter "></span>
									<template v-if="!isStateCityFilterClicked">
										<span class="count" v-if="selectedState || selectedMetroArea">
											<span>1</span>
										</span>
									</template>
								</span>
              </div>
							<div class="filter_sub_hd_txt">
								<template v-if="!isStateCityFilterClicked && (selectedState || selectedMetroArea)">
									<div v-if="selectedState">
										<span>{{selectedState.label}}</span>
									</div>
									<div v-if="selectedMetroArea">
										<span>{{selectedMetroArea.label}}</span>
									</div>
								</template>
								<template v-else>
									<span>US Data</span>
								</template>
							</div>
            </div>
          </template>

					<div class="container-fluid flex-grow-1 pg_content_container">

              <div class="filter_selection_flds_container" v-if="isStateCityFilterClicked">

								<div class="filter_fld_head">
									<div class="hd_txt">Filter by State or City</div>
								</div>

								<div>
								  <div class="filter_city_state">
								    <b-input-group class="row">
								      <div class="w-100">
								        <div>
							            <label for="state">Select State</label>
							            <v-select class="select-field" :disabled="disableSelectState" v-model='selectedState'
							              :options='formattedGeoIdMap.stateGeoIds' placeholder="Select or Search for a State" :class="!selectedState ? 'no_value_selected' : ''" :style="{'background-color': (!disableSelectState) ? '#f8eac9' : ''}"></v-select>
							            <span class="fld_info">
							            	<span v-if="disableSelectState">To select state clear the city selection first</span>
							            </span>
							          </div>
							          <div class="mt-2 text-center">
							            <label><strong>OR</strong></label>
							          </div>
							          <div style="margin-top: -15px">
							            <label for="city">Select City</label>
							            <v-select class="select-field" :disabled="disableSelectMetroArea" v-model='selectedMetroArea'
							              :options='formattedGeoIdMap.msaGeoIds' placeholder="Select or Search for a City" :class="!selectedMetroArea ? 'no_value_selected' : ''" :style="{'background-color': (!disableSelectMetroArea) ? '#ffebed' : ''}"></v-select>
							            <span class="fld_info">
							            	<span v-if="disableSelectMetroArea">To select city clear the state selection first</span>
							            </span>
							          </div>
								      </div>
								    </b-input-group>
								  </div>
                  <!--
								  <div class="ml-4" style="position: fixed; bottom: 160px;">
			        			<template v-if="selectedState || selectedMetroArea">
		              		<div v-if="selectedState">
		              			<span>{{selectedState.label}}</span>
		              		</div>
		              		<div v-if="selectedMetroArea">
		              			<span>{{selectedMetroArea.label}}</span>
		              		</div>
		              	</template>
		              	<template v-else>
		              		<span>US Data</span>
		              	</template>
		        			</div>
                  -->
								  <div class="btn_container">
		        				<b-btn @click="careerSearchClicked">ok</b-btn>
		        			</div>
								</div>
							</div>

							<div v-else>
	              <div v-if="career && career.uuid">

			              <b-tabs v-model="tabIndex">
			                <b-tab no-body title="Jobs" :title-link-class="linkClass(0)" title-item-class="text-center w-25">
			                  <div class="row jobs_sec">

													<div class="col-sm-3 col-xl-3 hd" style="margin-top: 25px; padding: 0px;">
												    <h2>Career Outlook</h2>
												    <span class="hd_bdr"></span>
												  </div>

													<div class="col-sm-3 col-xl-3">
														<div class="card sec_bx">
                              <div class="card-body">
                                <div class="row sec_row income_sec pt-2">

                                  <div class="col-5 ic_container">
                                    <span class="ic ic9-salary"></span>
                                  </div>
                                  <div class="col-7 val">
																		<template v-if="formattedCareer && formattedCareer.medianIncomePerYear">
																			$<span v-html="addCommaInNumber(formattedCareer.medianIncomePerYear)"></span>
																		</template>
																		<template v-else-if="careerOneStopInfo && careerOneStopInfo.medianEarning">
																			$<span v-html="addCommaInNumber(careerOneStopInfo.medianEarning)"></span>
																		</template>
                                  </div>
                                  <div class="col-12 label mt-1">
                                    Median Income
                                  </div>

                                </div>
                              </div>
                            </div>
													</div>

										      <div class="col-sm-3 col-xl-3" v-if="!selectedMetroArea">
														<div class="card sec_bx">
                              <div class="card-body">
                                <div class="row sec_row growth pt-2">

                                  <div class="col-5 gph_chart">
                                    <div class="row lg_row">
                                      <div class="col-6 lg">
                                        <span class="lg_txt">0%</span>
                                      </div>
                                      <div class="col-6 lg">
                                        <span class="lg_txt">15%</span>
                                      </div>
                                    </div>
                                    <div class="row gauge_sec">
                                      <div class="col-12">
                                        <doughnut-chart :chart-data="growthPieData" id="gauge" :options="growthPieOptions" @afterComplete="callDrawNeedle"></doughnut-chart>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-7 val mt-3">
																		<template v-if="formattedCareer && formattedCareer.growth">
																			{{formattedCareer.growth}} %
																		</template>
																		<template v-else-if="careerOneStopInfo && careerOneStopInfo.growth">
																			{{careerOneStopInfo.growth}} %
																		</template>
                                  </div>
                                  <div class="col-12 label mt-3">
                                    Estimated Job Growth 2020-2030
                                  </div>

                                </div>
                              </div>
                            </div>
													</div>

													<div class="col-sm-3 col-xl-3">
														<div class="card sec_bx">
															<div class="card-body">
																<div class="row sec_row">

																	<div class="col-5 ic_container" style="height: 57px;">
																		<span class="ic ic9-job2"></span>
																	</div>
																	<div class="col-7 val">
																		<template v-if="formattedCareer && formattedCareer.openings">
																				<span v-html="addCommaInNumber(formattedCareer.openings)"></span>
																		</template>
																		<template v-else-if="careerOneStopInfo && careerOneStopInfo.openings">
																				<span v-html="addCommaInNumber(careerOneStopInfo.openings)"></span>
																		</template>
																	</div>
																	<div class="col-12 label mt-2">
																		<div>
																			Job Postings 2020 - 2030
																		</div>
																	</div>

																</div>
															</div>
														</div>
													</div>

			                  </div>


									      <template v-if="careerOneStopInfo && careerOneStopInfo.annualWagePercentiles">

													<div class="row mt-4">
														<div class="col-sm-3 col-xl-3 hd" style="padding: 0px;">
															<h2>Annual Wage Percentiles</h2>
															<span class="hd_bdr"></span>
														</div>
													</div>

													<div class="row">
														<div class="col-sm-3 col-xl-3">
															<div class="row">
																<div class="col-12">
																	<div>
																		<div class="row gph_sec ace_sec">
																			<div class="col-12 mt-3 bar_chart_container bar_label_inside chart_annual_wage_percentiles">

																				<template v-for="(wage, index) in careerOneStopInfo.annualWagePercentiles">
																					<div class="row bar_row">
																						<div class="col-12">

																							<div id="annualWagePercentilesToolTip" class="chart_tooltip_popover"></div>
																							<b-popover :target="'popoverAnnualWage_' + index" triggers="hover" placement="top" class="tooltip_popover" container="annualWagePercentilesToolTip">
																								<div>
																									<div>Wage Percentiles</div>
																									<div>{{ wage.key }}</div>
																								</div>
																								<div>
																									<div><span v-html="'$' + addCommaInNumber(wage.value)"></span></div>
																								</div>
																							</b-popover>

																							<div class="bar_container" :id="'popoverAnnualWage_' + index">
																								<div class="bar_label">{{ wage.key }} </div>
																								<div class="bar_val"><span v-html="'$' + addCommaInNumber(wage.value)"></span></div>
																								<div class="bar" v-bind:style="{width:getNumberFromValue(wage.key) + '%'}"></div>
																							</div>

																						</div>
																					</div>
																				</template>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
									      </template>


									      <template v-if="educationItems && educationItems.length > 0">
													<div class="row mt-4">
														<div class="col-sm-3 col-xl-3 hd" style="padding: 0px;">
															<h2>National Educational Attainment</h2>
															<span class="hd_bdr"></span>
														</div>
													</div>

													<div class="row">
														<div class="col-sm-3 col-xl-3">
															<div class="row">
																<div class="col-12">
																	<div>
																		<div class="row gph_sec ace_sec">
																			<div class="col-12 mt-3 bar_chart_container bar_label_inside chart_annual_wage_percentiles">
																				<template v-for="(educationItems, index) in educationItems">
																					<div class="row bar_row">
																						<div class="col-12">
																							<!--
																						<div id="educationalAgeToolTip" class="chart_tooltip_popover"></div>
																						<div :id="'popoverEducation_' + index">
																							<div>{{ educationItems.Education_Level }}</div>
																							<div><span v-html="formatDecimalValue(educationItems.Percent) + '%'"></span></div>
																							<div v-bind:style="{width:educationItems.Percent + '%'}"></div>
																							<b-popover :target="'popoverEducation_' + index" triggers="hover" placement="top" class="tooltip_popover" container="educationalAgeToolTip">
																								<div>
																									<div>Education Level</div>
																									<div>{{ educationItems.Education_Level }}</div>
																								</div>
																								<div>
																									<div>{{ educationItems.Percent }}%</div>
																								</div>
																							</b-popover>
																						</div>
																					-->

																						<div class="bar_container" :id="'popoverAnnualWage_' + index">
																							<div class="bar_label">{{ educationItems.Education_Level }} </div>
																							<div class="bar_val">
																								<span v-html="formatDecimalValue(educationItems.Percent) + '%'"></span>
																							</div>
																							<div class="bar" v-bind:style="{width:getNumberFromValue(educationItems.Percent) + '%'}"></div>
																						</div>

																						</div>
																					</div>
																				</template>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</template>
                        <template v-if="experienceItems && experienceItems.length > 0">
													<div class="row mt-4">
														<div class="col-sm-3 col-xl-3 hd" style="padding: 0px;">
															<h2>Experience</h2>
															<span class="hd_bdr"></span>
														</div>
													</div>

													<div class="row">
														<div class="col-sm-3 col-xl-3">
															<div class="row">
																<div class="col-12">
																	<div>
																		<div class="row gph_sec ace_sec">
																			<div class="col-12 mt-3 bar_chart_container bar_label_inside chart_annual_wage_percentiles">
																				<template v-for="(experienceItem, index) in experienceItems">
																					<div class="row bar_row">
																						<div class="col-12">
																							<!--
																						<div id="educationalAgeToolTip" class="chart_tooltip_popover"></div>
																						<div :id="'popoverEducation_' + index">
																							<div>{{ educationItems.Education_Level }}</div>
																							<div><span v-html="formatDecimalValue(educationItems.Percent) + '%'"></span></div>
																							<div v-bind:style="{width:educationItems.Percent + '%'}"></div>
																							<b-popover :target="'popoverEducation_' + index" triggers="hover" placement="top" class="tooltip_popover" container="educationalAgeToolTip">
																								<div>
																									<div>Education Level</div>
																									<div>{{ educationItems.Education_Level }}</div>
																								</div>
																								<div>
																									<div>{{ educationItems.Percent }}%</div>
																								</div>
																							</b-popover>
																						</div>
																					-->

																						<div class="bar_container" :id="'popoverAnnualWage_' + index">
																							<div class="bar_label">{{ experienceItem.Experience_Level }} </div>
																							<div class="bar_val">
																								<span v-html="formatDecimalValue(experienceItem.Percent) + '%'"></span>
																							</div>
																							<div class="bar" v-bind:style="{width:getNumberFromValue(experienceItem.Percent) + '%'}"></div>
																						</div>

																						</div>
																					</div>
																				</template>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</template>

												<!--
                        <div class="row pg_sec" v-if="career.certifications && career.certifications.length > 0">
              						<div class="col-12 hd ace_sec_hd" aria-label="Experience">
              							<h2>Certifications</h2>
              							<span class="hd_bdr"></span>
              						</div>

              						<div class="col-12 gph_sec ace_sec" aria-label="Certifications Chart">
                            <ul>
                              <li v-for="c in career.certifications">{{c.name}}</li>
                            </ul>
              						</div>

              					</div>
												-->

												<template v-if="occupationAgeItems && occupationAgeItems.length > 0">
													<div class="row mt-4">
														<div class="col-sm-3 col-xl-3 hd" style="padding: 0px;">
													    <h2>Occupation Age Breakdown</h2>
													    <span class="hd_bdr"></span>
													  </div>
													</div>

													<div class="row">
														<div class="col-sm-3 col-xl-3">
													    <div class="row">
													      <div class="col-12">
													        <div>
																		<div class="row gph_sec ace_sec">
																			<div class="col-12 mt-3 bar_chart_container bar_label_inside chart_annual_wage_percentiles">
															          <template v-for="(occupationAgeItems, index) in occupationAgeItems">
																					<div class="row bar_row">
																						<div class="col-12">
															                <div id="occupationAgeToolTip" class="chart_tooltip_popover"></div>
															                <b-popover :target="'popoverOccuption_' + index" triggers="hover" placement="top" class="chart_tooltip_popover" container="occupationAgeToolTip">
															                  <div>
															                    <div>Age Group</div>
															                    <div>{{ occupationAgeItems.Age }}</div>
															                  </div>
															                  <div>
															                    <div>{{ occupationAgeItems.Percent }}%</div>
															                  </div>
															                </b-popover>

																							<div class="bar_container" :id="'popoverOccuption_' + index">
																								<div class="bar_label">{{occupationAgeItems.Age}}</div>
																								<div class="bar_val">{{occupationAgeItems.Percent}}% </div>
																								<div class="bar" v-bind:style="{width:occupationAgeItems.Percent + '%'}"></div>
																							</div>

															              </div>
															            </div>
															          </template>
													          	</div>
													          </div>
													        </div>
													      </div>
													    </div>
													  </div>
													</div>
												</template>


									      <template v-if="formattedCareer.percentByGenderWomen && formattedCareer.percentByGenderMen">
													<div class="row mt-4">
														<div class="col-sm-3 col-xl-3 hd" style="padding: 0px;">
													    <h2>Gender Breakdown</h2>
													    <span class="hd_bdr"></span>
													  </div>
													</div>

													<div class="row mt-3">
													  <div class="col-sm-3 col-xl-3">

															<div class="row gph_sec ace_sec">

																<div class="col-4" v-if="genderDonutChartItems && genderDonutChartItems.length > 0">
													        <vc-donut :size="genderDonutChartSize" unit="px" :sections="genderDonutChartItems"></vc-donut>
													      </div>

																<div class="col-8 mt-3 bar_chart_container bar_label_inside chart_gender_breakdown">
																	<div class="row bar_row">
																		<div class="col-12">
													              <div id="menToolTip" class="tooltip_popover"></div>
													              <b-popover target="popover_men" triggers="hover" placement="top" class="tooltip_popover" container="menToolTip">
													                <div>
													                  <div>Men</div>
													                  <div>{{formattedCareer.percentByGenderMen}}%</div>
													                </div>
													              </b-popover>

																				<div class="bar_container" id="popover_men">
													                <div class="bar_label">Men</div>
													                <div class="bar_val"><span>{{formattedCareer.percentByGenderMen}}%</span></div>
													                <div class="bar" v-bind:style="{width:formattedCareer.percentByGenderMen + '%'}"></div>
													              </div>

													            </div>
													          </div>

																		<div class="row bar_row">
																			<div class="col-12">
													              <div id="womenToolTip" class="tooltip_popover"></div>
													              <b-popover target="popover_women" triggers="hover" placement="top" class="tooltip_popover" container="womenToolTip">
													                <div>
													                  <div>Women</div>
													                  <div>{{formattedCareer.percentByGenderWomen }}%</div>
													                </div>
													              </b-popover>

																				<div class="bar_container" id="popover_women">
													                <div class="bar_label">Women</div>
													                <div class="bar_val"><span>{{formattedCareer.percentByGenderWomen}}% </span></div>
													                <div class="bar" v-bind:style="{width:formattedCareer.percentByGenderWomen + '%'}"></div>
													              </div>

													            </div>
													          </div>
													        </div>
													      </div>
													  </div>
													</div>
												</template>

			                </b-tab>

			                <b-tab no-body title="Companies" :title-link-class="linkClass(1)" title-item-class="text-center w-50">
												<template v-if="topCompaniesItems && topCompaniesItems.length > 0">

													<div class="row">
														<div class="col-sm-3 col-xl-3 hd mt-4" style="padding: 0;">
													    <h2>Top Companies Posting</h2>
													    <span class="hd_bdr"></span>
													  </div>
													</div>

													<div class="row">
													  <div class="col-sm-3 col-xl-3">
													    <div class="row">
													      <div class="col-12">
													        <div>
													          <div class="row gph_sec" style="margin: 0 3px;">
													            <div class="col-12 time_chart_container chart_companies_posting">
														            <template v-for="(topCompaniesItems, index) in topCompaniesItems">
														              <div class="bar_block">

														                <div id="companiesPostingToolTip" class="chart_tooltip_popover"></div>
														                <b-popover :target="'popoverTarget_' + index" triggers="hover" placement="top" class="tooltip_popover" container="companiesPostingToolTip">
														                  <div>
														                    <div><span v-html="checkForCompanyName(topCompaniesItems.Company)"></span></div>
														                  </div>
														                  <div>
														                    <div>Postings</div>
														                    <div><span v-html="addCommaInNumber(topCompaniesItems.Total)"></span></div>
														                  </div>
														                </b-popover>

														                <div class="bar_block_inner" :id="'popoverTarget_' + index">
														                  <div class="row">
														                    <div class="col-12 bar_title"><span v-html="checkForCompanyName(topCompaniesItems.Company)"></span></div>
														                    <div class="col-12 bar_val_1">Postings <span v-html="addCommaInNumber(topCompaniesItems.Total)"></span></div>
														                  </div>
														                </div>

														              </div>
														            </template>
													            </div>
													          </div>
													        </div>
													      </div>
													    </div>
													  </div>
													</div>

												</template>

												<template v-else class="text-center mt-5 mb-5">
													<h4>Top Companies are not available</h4>
												</template>

			                </b-tab>


			                <b-tab no-body title="Skills" :title-link-class="linkClass(2)" title-item-class="text-center w-25">
												<template v-if="topSkillsItems && topSkillsItems.length > 0">

													<div class="row">
														<div class="col-sm-3 col-xl-3 hd mt-4" style="padding: 0;">
															<h2>Top In-Demand Skills within Job Postings</h2>
															<span class="hd_bdr"></span>
														</div>
													</div>

													<div class="row">
														<div class="col-sm-3 col-xl-3">
															<div class="row">
																<div class="col-12">
																	<div>
																		<div class="row gph_sec" style="margin: 0 3px;">
													            <div class="col-12 time_chart_container chart_companies_posting">
																				<template v-for="(topSkillsItems, index) in topSkillsItems">
																					<div class="bar_block">

																						<div id="skillsToolTip" class="chart_tooltip_popover"></div>
																						<b-popover :target="'popoverTarget2_skill_' + index" triggers="hover" placement="top" class="tooltip_popover" container="skillsToolTip">
																							<div>
																								<div class="label">Skill</div>
																								<div class="val">{{topSkillsItems.Skill}}</div>
																							</div>
																							<div>
																								<div class="label">Postings</div>
																								<div><span v-html="addCommaInNumber(topSkillsItems.Postings_with_Skill)"></span></div>
																							</div>
																						</b-popover>

																						<div class="bar_block_inner" :id="'popoverTarget2_skill_' + index">
																							<div class="row">
																								<div class="col-12 bar_title">{{ topSkillsItems.Skill }} </div>
																							</div>
																							<div class="row">
																								<div class="col-6 bar_val_1">Postings <span v-html="addCommaInNumber(topSkillsItems.Postings_with_Skill)"></span></div>
                                                <div class="col-5 tag_skill">
                                                  <template v-for="type in topSkillsItems.Types">
                                                    <span class="tag ace_sec_txt" :class="type" v-if="type === 'baselineSkills'">F</span>
                                                    <!--
                                                    <span class="tag ace_sec_txt" :class="type" v-if="type === 'definingSkills'">D</span>
                                                    <span class="tag ace_sec_txt" :class="type" v-if="type === 'necessarySkills'">N</span>
                                                    <span class="tag ace_sec_txt" :class="type" v-if="type === 'distinguishingSkills'">Dis</span>
                                                    -->
                                                    <span class="tag ace_sec_txt" :class="type" v-if="type === 'specializedSkills'">S</span>
                                                    <span class="tag ace_sec_txt" :class="type" v-if="type === 'salaryBoostSkills'">$</span>
                                                  </template>
                                                </div>
                                                <div class="col-12 bar_val_1" v-if="topSkillsItems.Marginal_Value !== 'null'">
                                                  ${{topSkillsItems.Marginal_Value}} pa
                                                </div>
																							</div>
																						</div>

																					</div>
																				</template>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>

												</template>
                        <template v-if="formattedCareer.topSkillsLabel && formattedCareer.topSkillsLabel.length > 0">

													<div class="row">
														<div class="col-sm-3 col-xl-3 hd mt-4" style="padding: 0;">
															<h2>Skills</h2>
															<span class="hd_bdr"></span>
														</div>
													</div>

													<div class="row">
														<div class="col-sm-3 col-xl-3">
															<div class="row">
																<div class="col-12">
																	<div>
																		<div class="row gph_sec" style="margin: 0 3px;">
													            <div class="col-12 time_chart_container chart_companies_posting">
																				<template v-for="(topSkillsItems, index) in formattedCareer.topSkillsLabel">
																					<div class="bar_block">

																						<div id="skillsToolTip" class="chart_tooltip_popover"></div>
																						<b-popover :target="'popoverTarget2_skill_' + index" triggers="hover" placement="top" class="tooltip_popover" container="skillsToolTip">
																							<div>
																								<div class="label">Skill</div>
																								<div class="val">{{topSkillsItems}}</div>
																							</div>
																						</b-popover>

																						<div class="bar_block_inner" :id="'popoverTarget2_skill_' + index">
																							<div class="row">
																								<div class="col-12 bar_title">{{ topSkillsItems }} </div>
																							</div>
																						</div>

																					</div>
																				</template>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>

												</template>
                        <template v-if="formattedCareer.abilitiesLabel && formattedCareer.abilitiesLabel.length > 0">

													<div class="row">
														<div class="col-sm-3 col-xl-3 hd mt-4" style="padding: 0;">
															<h2>Abilities</h2>
															<span class="hd_bdr"></span>
														</div>
													</div>

													<div class="row">
														<div class="col-sm-3 col-xl-3">
															<div class="row">
																<div class="col-12">
																	<div>
																		<div class="row gph_sec" style="margin: 0 3px;">
													            <div class="col-12 time_chart_container chart_companies_posting">
																				<template v-for="(topSkillsItems, index) in formattedCareer.abilitiesLabel">
																					<div class="bar_block">

																						<div id="skillsToolTip" class="chart_tooltip_popover"></div>
																						<b-popover :target="'popoverTarget2_skill_' + index" triggers="hover" placement="top" class="tooltip_popover" container="skillsToolTip">
																							<div>
																								<div class="label">Abilities</div>
																								<div class="val">{{topSkillsItems}}</div>
																							</div>
																						</b-popover>

																						<div class="bar_block_inner" :id="'popoverTarget2_skill_' + index">
																							<div class="row">
																								<div class="col-12 bar_title">{{ topSkillsItems }} </div>
																							</div>
																						</div>

																					</div>
																				</template>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>

												</template>
                        <template v-if="formattedCareer.knowledgeLabel && formattedCareer.knowledgeLabel.length > 0">

													<div class="row">
														<div class="col-sm-3 col-xl-3 hd mt-4" style="padding: 0;">
															<h2>Knowledge</h2>
															<span class="hd_bdr"></span>
														</div>
													</div>

													<div class="row">
														<div class="col-sm-3 col-xl-3">
															<div class="row">
																<div class="col-12">
																	<div>
																		<div class="row gph_sec" style="margin: 0 3px;">
													            <div class="col-12 time_chart_container chart_companies_posting">
																				<template v-for="(topSkillsItems, index) in formattedCareer.knowledgeLabel">
																					<div class="bar_block">

																						<div id="skillsToolTip" class="chart_tooltip_popover"></div>
																						<b-popover :target="'popoverTarget2_skill_' + index" triggers="hover" placement="top" class="tooltip_popover" container="skillsToolTip">
																							<div>
																								<div class="label">Knowledge</div>
																								<div class="val">{{topSkillsItems}}</div>
																							</div>
																						</b-popover>

																						<div class="bar_block_inner" :id="'popoverTarget2_skill_' + index">
																							<div class="row">
																								<div class="col-12 bar_title">{{ topSkillsItems }} </div>
																							</div>
																						</div>

																					</div>
																				</template>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>

												</template>

												<template v-if="topSkillsItems.length === 0 && formattedCareer.topSkillsLabel.length === 0 && formattedCareer.abilitiesLabel.length === 0 && formattedCareer.knowledgeLabel.length === 0" class="text-center mt-5 mb-5">
													<h4>Top Skills are not available</h4>
												</template>

			                </b-tab>

			              </b-tabs>

										<div class="data_source_info" v-if="isEMSIFeatureEnabled" style="padding-left: 15px; margin-bottom: 15px;">Data Source: Burning Glass Technologies.</div>

								</div>
							</div>

          </div>


				</template>

        <career-footer-navbar :pageTitle="'Introduction'" :returnTo="returnTo" :params="{code: code, cipCode: cipCode, programGuideCode: programGuideCode, type: type, isComingFromBookmark: isComingFromBookmark}"></career-footer-navbar>

			</div>
    </div>

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import CareerTitle from './CareerTitle'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'
  import Navbar from '../../misc/components/./Navbar'
  import DoughnutChart from './DoughnutChart'
  import CareerFooterNavbar from '../../misc/components/./CareerFooterNavbar'
  import _ from 'lodash'
	import VClamp from 'vue-clamp'

  export default {
    name: 'career-detail',
    props: ['code', 'cipCode', 'programGuideCode', 'type', 'isComingFromBookmark'],
    components: {
      Navbar,
      CareerTitle,
      DoughnutChart,
      CareerFooterNavbar,
			VClamp
    },
    data: () => {
      return {
        tabIndex: 0,
        isLoading: true,
        genderFields: [' ', 'Gender', 'Percent'],
        genderItems: [],
        genderDonutChartItems: [],
        genderDonutChartSize: 100,
        occupationAgeFields: [' ', 'Age', 'Percent'],
        occupationAgeItems: [],
        occupationAgeDonutChartSize: 100,
        occupationAgeDonutChartItems: [],
        educationFields: [' ', 'Education_Level', 'Percent'],
        educationItems: [],
        experienceItems: [],
        educationDonutChartItems: [],
        experienceDonutChartItems: [],
        educationDonutChartSize: 100,
        topCompaniesFields: ['Company', 'Total', 'Unique', 'Posting_Intensity'],
        topCompaniesItems: [],
        topSkillsFields: ['Skill', 'Postings_with_Skill'],
        topSkillsItems: [],
        selectedState: null,
        selectedMetroArea: null,
        disableSelectState: false,
        disableSelectMetroArea: false,
        growthPieOptions: {
          rotation: 1 * Math.PI,
          circumference: 1 * Math.PI,
          tooltips: {
            enabled: false
          }
        },
        wagePercentileMap: {
          'annualEarning10thPercentile': '10th percentile',
          'annualEarning25thPercentile': '25th percentile',
          'annualEarning50thPercentile': '50th percentile',
          'annualEarning75thPercentile': '75th percentile',
          'annualEarning90thPercentile': '90th percentile'
        },
        isStateCityFilterClicked: false
      }
    },

    mounted () {
      this.loadCareerDetail()
    },

    updated () {
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.callDrawNeedle()
        })
      })
    },

    methods: {
      ...mapActions([
        'loadUserObj',
        'loadInstitutionPackage',
        'loadCareer',
        'loadCareerResult',
        'loadCareerOneStopInfo',
        'resetCareerResult',
        'loadGeoIds'
      ]),
      linkClass (idx) {
        if (this.tabIndex === idx) {
          return ['active']
        } else {
          return ['bg-primary', 'text-light']
        }
      },
      callDrawNeedle () {
        let careerOneStopInfo = this.careerOneStopInfo
        if (this.formattedCareer && this.formattedCareer.uuid) {
          careerOneStopInfo = this.formattedCareer
        }
        if (!document || !document.getElementById('gauge')) {
          return
        }
        let canvas = document.getElementById('gauge').childNodes[1]
        if (!canvas) {
          return
        }
        if (!careerOneStopInfo || careerOneStopInfo.growth <= -10) {
          this.drawNeedle(canvas, 50, -170 * Math.PI / 180)
        } else if (careerOneStopInfo && careerOneStopInfo.growth >= -10 && careerOneStopInfo.growth < -5) {
          this.drawNeedle(canvas, 50, -150 * Math.PI / 180)
        }   if (careerOneStopInfo && careerOneStopInfo.growth >= -5 && careerOneStopInfo.growth < 0) {
          this.drawNeedle(canvas, 50, -130 * Math.PI / 180)
        } else if (careerOneStopInfo && careerOneStopInfo.growth >= 0 && careerOneStopInfo.growth < 5) {
          this.drawNeedle(canvas, 50, -110 * Math.PI / 180)
        } else if (careerOneStopInfo && careerOneStopInfo.growth >= 5 && careerOneStopInfo.growth < 10) {
          this.drawNeedle(canvas, 50, -90 * Math.PI / 180)
        } else if (careerOneStopInfo && careerOneStopInfo.growth >= 10 && careerOneStopInfo.growth < 15) {
          this.drawNeedle(canvas, 50, -70 * Math.PI / 180)
        } else if (careerOneStopInfo && careerOneStopInfo.growth >= 15 && careerOneStopInfo.growth < 20) {
          this.drawNeedle(canvas, 50, -50 * Math.PI / 180)
        } else if (careerOneStopInfo && careerOneStopInfo.growth >= 20 && careerOneStopInfo.growth < 25) {
          this.drawNeedle(canvas, 50, -30 * Math.PI / 180)
        } else if (careerOneStopInfo && careerOneStopInfo.growth >= 25) {
          this.drawNeedle(canvas, 50, -10 * Math.PI / 180)
        }
      },
      drawNeedle (canvas, radius, radianAngle) {
        var ctx = canvas.getContext('2d')
        var cw = canvas.offsetWidth
        var ch = canvas.offsetHeight
        var cx = cw / 2
        var cy = ch - (ch / 4)

        ctx.translate(cx, cy)
        ctx.rotate(radianAngle)
        ctx.beginPath()
        ctx.moveTo(0, -5)
        ctx.lineTo(radius, 0)
        ctx.lineTo(0, 5)
        ctx.fillStyle = 'rgba(100, 100, 100, 1)'
        ctx.fill()
        ctx.rotate(-radianAngle)
        ctx.translate(-cx, -cy)
        ctx.beginPath()
        ctx.arc(cx, cy, 7, 0, Math.PI * 2)
        ctx.fill()
      },
      formatOptionsForVSelect (map) {
        let formatted = []
        Object.keys(map).sort().forEach((key, i) => {
          formatted.push({id: key, label: map[key]})
        })
        formatted.sort((a, b) => (a.label >= b.label) ? 1 : -1)
        return formatted
      },
      resetData () {
        this.genderItems = []
        this.occupationAgeItems = []
        this.educationItems = []
        this.experienceItems = []
        this.topCompaniesItems = []
        this.topSkillsItems = []
        this.genderDonutChartItems = []
        this.occupationAgeDonutChartItems = []
        this.educationDonutChartItems = []
      },
      async loadCareerDetail () {
        this.resetData()
        this.resetCareerResult()
        await this.loadUserObj()
        await this.loadInstitutionPackage({uuid: this.userObj.institutionId, isAggregated: false})
        await this.loadCareer(this.code)
        await this.loadCareerOneStopInfo(this.code)
        this.loadGeoIds()
        this.$forceUpdate()
        this.isLoading = false
      },
      getLocationParamForCareerSearch () {
        let locationParam = ''
        let selectedState = (this.selectedState && this.selectedState.label) ? this.selectedState.label : null
        let selectedMetroArea = (this.selectedMetroArea && this.selectedMetroArea.label) ? this.selectedMetroArea.label : null
        let selectedCounty = (this.selectedCounty && this.selectedCounty.label) ? this.selectedCounty.label : null

        if (selectedState) {
          locationParam = 'state:' + this.labelsToCodesMap.stateGeoIds[selectedState]
        } else if (selectedMetroArea) {
          locationParam = 'msa:' + this.labelsToCodesMap.msaGeoIds[selectedMetroArea]
        } else if (selectedCounty) {
          locationParam = 'county:' + this.labelsToCodesMap.countyGeoIds[selectedCounty]
        }
        return locationParam
      },
      async careerSearchClicked () {
        this.isStateCityFilterClicked = false
        this.isLoading = true
        let careerCode = this.formattedCareer.code
        if (!careerCode) {
          this.isLoading = false
          return
        }
        let locationParam = this.getLocationParamForCareerSearch()
        await this.loadCareerResult({careerCode: careerCode, locationParam: locationParam})
        this.$forceUpdate()
        this.isLoading = false
      },
      getExploreSearchPackage () {
        let packages = this.packages
        if (!packages || !packages.length || packages.length <= 0) {
          return {}
        }
        return PackageUtil.getExploreSearchPackage(packages)
      },
      checkForCompanyName (companyName) {
        if (companyName === '[Unknown]') {
          return 'Others'
        }
        return companyName
      },
      addCommaInNumber (numValue) {
        if (numValue || numValue.length) {
          let value = Math.floor(numValue)
          return Number(value).toLocaleString()
        }
        return numValue
      },
      getNumberFromValue (entityValue) {
        if (entityValue) {
          return entityValue.match(/\d+/)
        }
      },
      formatDecimalValue (numValue) {
        if (numValue === '0') {
          return '< 0.1'
        }
        return parseFloat(numValue).toFixed(1)
      },
	    hideUserNamePopup () {
				this.$refs.userNamePopupContainer.$emit('close')
      }
    },
    computed: {
      ...mapState({
        'userObj': state => state.login.userObj,
        'career': state => state.career.careerObject,
        'careerResult': state => state.career.careerResultObject,
        'careerOneStopData': state => state.career.careerOneStopInfo,
        'geoIdMap': state => state.career.geoIdMap,
        'enabledFeatures': state => state.dashboard.enabledFeatures,
        'packages': state => state.dashboard.packages
      }),
      returnTo () {
        if (this.isComingFromBookmark) {
          if (this.$route.query.returnTo) {
            return 'programGuideCareers'
          }
        }
        return this.$route.query.returnTo || 'careerHome'
      },
      careerOneStopInfo () {
        let careerOneStopData = this.careerOneStopData
        if (!careerOneStopData || !careerOneStopData.uuid) {
          return {}
        }
        let career = _.cloneDeep(careerOneStopData)
        let annualWagePercentiles = []
        let wagePercentileMap = this.wagePercentileMap
        Object.keys(wagePercentileMap).forEach(key => {
          const wage = {}
          wage.key = wagePercentileMap[key]
          wage.value = career[key] || 'N/A'
          annualWagePercentiles.push(wage)
        })
        career.annualWagePercentiles = annualWagePercentiles
        return career
      },
      isEMSIFeatureEnabled () {
        let emsiFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_EMSI_SOURCE]
        let bgtFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_BGT_SOURCE]
        let lightcastFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_LIGHTCAST_SOURCE]
        return ((emsiFeature && emsiFeature.enabled) || (bgtFeature && bgtFeature.enabled) || (lightcastFeature && lightcastFeature.enabled))
      },
      jobPostingsPieData () {
        let isEMSIFeatureEnabled = this.isEMSIFeatureEnabled
        let careerOneStopInfo = this.careerOneStopInfo
        let formattedCareer = this.formattedCareer
        let data = {
          datasets: [
            {
              label: 'Job Postings',
              backgroundColor: '#8db350',
              data: []
            }
          ]
        }
        if (isEMSIFeatureEnabled && formattedCareer && formattedCareer.openings) {
          data.datasets[0].data.push(formattedCareer.openings)
        }
        if (!isEMSIFeatureEnabled || (data.datasets[0].data.length === 0)) {
          if (careerOneStopInfo && careerOneStopInfo.openings) {
            data.datasets[0].data.push(careerOneStopInfo.openings)
          }
        }
        return data
      },
      growthPieData () {
        let data = {
          datasets: [
            {
              labels: 'Growth',
              backgroundColor: ['#f5b518', '#9fc958', '#0a7714'],
              data: [15, 15, 15]
            }
          ]
        }
        if (this.formattedCareer && this.formattedCareer.growth) {
          return data
        }
        return {}
      },
      medianIncomePieData () {
        let isEMSIFeatureEnabled = this.isEMSIFeatureEnabled
        let careerOneStopInfo = this.careerOneStopInfo
        let formattedCareer = this.formattedCareer
        let data = {
          datasets: [
            {
              label: 'Median Income',
              backgroundColor: '#8db350',
              data: []
            }
          ]
        }
        if (isEMSIFeatureEnabled && formattedCareer && formattedCareer.medianIncomePerYear) {
          data.datasets[0].data.push(formattedCareer.medianIncomePerYear)
        }
        if (!isEMSIFeatureEnabled || (data.datasets[0].data.length === 0)) {
          if (careerOneStopInfo && careerOneStopInfo.medianEarning) {
            data.datasets[0].data.push(careerOneStopInfo.medianEarning)
          }
        }
        return data
      },
      formattedCareer () {
        let formattedCareer = (this.careerResult && this.careerResult.name) ? this.careerResult : this.career
        if (!formattedCareer) {
          return {}
        }
        this.resetData()
        if (formattedCareer.occupationOverview && formattedCareer.occupationOverview.length > 0) {
          formattedCareer.formattedOccupation = JSON.parse(formattedCareer.occupationOverview)
        }
        if (formattedCareer.postingOverview && formattedCareer.postingOverview.length > 0) {
          formattedCareer.formattedPosting = JSON.parse(formattedCareer.postingOverview)
        }
        if (formattedCareer.majors && formattedCareer.majors.length > 0) {
          formattedCareer.majorsLabel = formattedCareer.majors.join(', ')
        }
        if (formattedCareer.departments && formattedCareer.departments.length > 0) {
          formattedCareer.departmentsLabel = formattedCareer.departments.join(', ')
        }
        if (formattedCareer.industries && formattedCareer.industries.length > 0) {
          formattedCareer.industriesLabel = formattedCareer.industries.join(', ')
        }
        if (formattedCareer.percentByGenderWomen && formattedCareer.percentByGenderMen) {
          // set label dynamically from backend to show the year's percentage breakdown
          let genderPercentLabel = 'Percent'
          if (formattedCareer.formattedOccupation && formattedCareer.formattedOccupation.year) {
            genderPercentLabel = formattedCareer.formattedOccupation.year + ' Percent'
          }
          this.genderFields[2] = genderPercentLabel
          // TODO set CSS gender icons/legend in the first slot instead of ''
          let malePercentInfo = {'': '', 'Gender': 'Male'}
          let femalePercentInfo = {'': '', 'Gender': 'Female'}
          malePercentInfo[genderPercentLabel] = formattedCareer.percentByGenderMen
          femalePercentInfo[genderPercentLabel] = formattedCareer.percentByGenderWomen
          this.genderItems.push(malePercentInfo)
          this.genderItems.push(femalePercentInfo)

          this.genderDonutChartItems.push({label: 'Male', value: Number(formattedCareer.percentByGenderMen), color: '#1b9afa'})
          this.genderDonutChartItems.push({label: 'Female', value: Number(formattedCareer.percentByGenderWomen), color: '#d487fa'})
        }
        if (formattedCareer.percentByAge && formattedCareer.percentByAge.length > 0) {
          formattedCareer.percentByAge.forEach((item, i) => {
            let currItem = JSON.parse(item)
            // the backend sends the same 8 age brackets twice, should be fixed at some point
            // but this workaround suffices for now
            if (i <= 7) {
              // TODO put CSS gender icons in the first slot instead of ''
              this.occupationAgeItems.push({' ': '', 'Age': currItem.group, 'Percent': currItem.percent})
              if (currItem.percent > 0) {
                this.occupationAgeDonutChartItems.push({label: currItem.group, value: currItem.percent})
              }
            }
          })
        }
        if (formattedCareer.education && formattedCareer.education.length > 0) {
          formattedCareer.education.forEach((item) => {
            this.educationItems.push({' ': '', 'Education_Level': item.level, 'Percent': item.score})
            if (item.score > 0) {
              this.educationDonutChartItems.push({label: item.level, value: item.score - 0.01})
            }
          })
        }
        if (formattedCareer.experience && formattedCareer.experience.length > 0) {
          formattedCareer.experience.forEach((item) => {
            this.experienceItems.push({' ': '', 'Experience_Level': item.level, 'Percent': item.score})
            if (item.score > 0) {
              this.experienceDonutChartItems.push({label: item.level, value: item.score - 0.01})
            }
          })
        }
        if (formattedCareer.topPostingCompanies && formattedCareer.topPostingCompanies.length > 0) {
          formattedCareer.topPostingCompanies.forEach((item) => {
            let currItem = JSON.parse(item)
            this.topCompaniesItems.push({
              'Company': currItem.name,
              'Total': (currItem.total_postings),
              'Unique': (currItem.unique_postings),
              'Posting_Intensity': (Math.round(currItem.posting_intensity) + ':1')
            })
          })
          this.topCompaniesItems = this.topCompaniesItems.sort((a, b) => (Number(a.Total) <= Number(b.Total)) ? 1 : -1)
        }
        let isEMSIFeatureEnabled = this.isEMSIFeatureEnabled
        let hasEMSISkills = formattedCareer.skills && formattedCareer.skills.length
        let hasONETSkills = formattedCareer.careerSkills && formattedCareer.careerSkills.length
        if ((isEMSIFeatureEnabled) && hasEMSISkills) {
          formattedCareer.skills.forEach((item) => {
            let currItem = JSON.parse(item)
            this.topSkillsItems.push({
              'Skill': currItem.name,
              'Postings_with_Skill': currItem.unique_postings,
              'Types': currItem.types,
              'Marginal_Value': currItem.marginal_value
            })
          })
          this.topSkillsItems = this.topSkillsItems.sort((a, b) => (Number(a.Postings_with_Skill) <= Number(b.Postings_with_Skill)) ? 1 : -1)
        }
        if (!isEMSIFeatureEnabled && hasONETSkills) {
          let knowledges = []
          let skills = []
          let abilities = []
          formattedCareer.careerSkills.forEach(careerSkill => {
            let title = careerSkill.title
            if (careerSkill.type === 'KNOWLEDGE') {
              knowledges.push(title)
            }
            if (careerSkill.type === 'SKILL') {
              skills.push(title)
            }
            if (careerSkill.type === 'ABILITY') {
              abilities.push(title)
            }
          })
          formattedCareer.knowledgeLabel = knowledges
          formattedCareer.topSkillsLabel = skills
          formattedCareer.abilitiesLabel = abilities
        }
        formattedCareer.thumbnailURI = this.career.thumbnailURI
        return formattedCareer
      },
      formattedGeoIdMap () {
        let formattedMap = {}
        let map = this.geoIdMap

        if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
          formattedMap.stateGeoIds = this.formatOptionsForVSelect(map.stateGeoIds)
          formattedMap.msaGeoIds = this.formatOptionsForVSelect(map.msaGeoIds)
          formattedMap.countyGeoIds = this.formatOptionsForVSelect(map.countyGeoIds)
        }
        return formattedMap
      },
      labelsToCodesMap () {
        let map = this.geoIdMap
        let formattedMap = {}
        if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
          formattedMap.stateGeoIds = _.invert(map.stateGeoIds)
          formattedMap.msaGeoIds = _.invert(map.msaGeoIds)
          formattedMap.countyGeoIds = _.invert(map.countyGeoIds)
        }
        return formattedMap
      },
      exploreCareerDetailFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.EXPLORE_CAREER_DETAIL
        let exploreSearchPackage = this.getExploreSearchPackage()
        return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
      },
      showMedianIncome () {
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryMedianIncome) {
          return false
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryMedianIncome.enabled
      },
      medianIncomeLabel () {
        const defaultLabel = 'median income'
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryMedianIncome) {
          return defaultLabel
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryMedianIncome.label || defaultLabel
      },
      showJobPostings () {
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryJobPostings) {
          return false
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryJobPostings.enabled
      },
      jobPostingsLabel () {
        const defaultLabel = 'job postings'
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryJobPostings) {
          return defaultLabel
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryJobPostings.label || defaultLabel
      },
      showGrowthRate () {
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryGrowthRate) {
          return false
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryGrowthRate.enabled
      },
      growthRateLabel () {
        const defaultLabel = 'growth rate'
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryGrowthRate) {
          return defaultLabel
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryGrowthRate.label || defaultLabel
      },
      currencyLabel () {
        return '$'
      }
    },
    watch: {
      selectedState (newState) {
        if (!newState) {
          this.disableSelectState = false
          this.disableSelectMetroArea = false
        } else {
          this.disableSelectState = false
          this.disableSelectMetroArea = true
        }
        this.$forceUpdate()
      },
      selectedMetroArea (newMSA) {
        if (!newMSA) {
          this.disableSelectState = false
          this.disableSelectMetroArea = false
        } else {
          this.disableSelectState = true
          this.disableSelectMetroArea = false
        }
        this.$forceUpdate()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/career/components/CareerDetail.vue